import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import {
  HashRouter as Router, Route, Switch,
} from 'react-router-dom';
import theme from './theme';
import Admin from './pages/admin';
import Politician from './pages/politician';
import VerifyWrapper from './pages/verify-wrapper';

const PageShell = Page => props => (
  <VerifyWrapper Page={Page} {...props} />
);

const App = () => (
  <Router>
    <MuiThemeProvider theme={theme}>
      <Switch>
        <Route path="/admin" component={PageShell(Admin)} />
        <Route path="/" component={PageShell(Politician)} />
      </Switch>
    </MuiThemeProvider>
  </Router>
);

export default App;
